import { IConstructor } from '@/interfaces/constructor.interfaces';

const getConstructorItemsByPath = (constructor: IConstructor, path?: string | null) => {
  if (!path) {
    return;
  }
  return constructor?.[path];
};

export default getConstructorItemsByPath;
